export default "__VITE_ASSET__uxCAKxzz__"